export default __webpack_public_path__ + "static/media/blog.8eded6c8.webp";